(function () {
	var swiperInformationBar = null;
	var mobileQuery = window.matchMedia("(max-width: 749px), (orientation: landscape) and (max-height: 500px)");

	var getRoot = function () {
		return document.querySelector(".swiper--information-bar");
	};

	var getWrapper = function (root) {
		return root ? root.querySelector(".information-bar__wrapper") : null;
	};

	var getSlides = function (root) {
		return root ? root.querySelectorAll(".information-bar__link") : [];
	};

	var addClasses = function (root) {
		var wrapper = getWrapper(root);
		var slides = getSlides(root);
		var i;

		if (wrapper && !wrapper.classList.contains("swiper-wrapper")) {
			wrapper.classList.add("swiper-wrapper");
		}

		for (i = 0; i < slides.length; i += 1) {
			if (!slides[i].classList.contains("swiper-slide")) {
				slides[i].classList.add("swiper-slide");
			}
		}
	};

	var cleanupDom = function (root) {
		var wrapper = getWrapper(root);
		var slides = getSlides(root);
		var duplicateSlides = root.querySelectorAll(".swiper-slide-duplicate");
		var i;

		if (wrapper) {
			wrapper.classList.remove("swiper-wrapper");
			wrapper.removeAttribute("style");
		}

		for (i = 0; i < slides.length; i += 1) {
			slides[i].removeAttribute("style");
			slides[i].classList.remove("swiper-slide");
		}

		for (i = 0; i < duplicateSlides.length; i += 1) {
			duplicateSlides[i].parentNode.removeChild(duplicateSlides[i]);
		}
	};

	var initInformationBarSlider = function () {
		var root = getRoot();

		if (!root || swiperInformationBar) {
			return;
		}

		addClasses(root);

		swiperInformationBar = new Swiper(root, {
			loop: false,
			rewind: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false
			},
			slidesPerView: 1,
			slidesPerGroup: 1
		});
	};

	var destroySlider = function () {
		var root = getRoot();

		if (!root) {
			return;
		}

		if (swiperInformationBar) {
			swiperInformationBar.destroy(true, true);
			swiperInformationBar = null;
		}

		cleanupDom(root);
	};

	var syncMode = function () {
		if (mobileQuery.matches) {
			initInformationBarSlider();
		} else {
			destroySlider();
		}
	};

	if (mobileQuery.addEventListener) {
		mobileQuery.addEventListener("change", syncMode);
	} else {
		mobileQuery.addListener(syncMode);
	}

	document.addEventListener("shopify:section:load", function () {
		destroySlider();
		syncMode();
	});

	syncMode();
})();
